export enum DriverHabit {
	URBAN = 'URBAN',
	HIGHWAY = 'HIGHWAY',
	COMBINED = 'COMBINED',
}
